<div class="mb-6">
  @if (props.label && props.hideLabel !== true) {
    <ng-container>
      <label
        class="relative mb-2 inline-block pr-5 font-medium"
        [ngClass]="{ 'text-grey-300': props.disabled }"
        [for]="id"
      >
        {{ props.label }}

        @if (props.showHelp) {
          <span
            data-test-id="helpLayer"
            class="absolute top-0 right-0"
            (mouseover)="
              props.helpOverCallback ? props.helpOverCallback(field) : null
            "
            (focus)="
              props.helpOverCallback ? props.helpOverCallback(field) : null
            "
            (mouseleave)="
              props.helpLeaveCallback ? props.helpLeaveCallback(field) : null
            "
          >
            <svg-icon
              class="size-4"
              src="assets/icons/General/help-circle.svg"
            />
          </span>
        }
        @if (props.showOptionalMarker && !props.required) {
          <span class="text-grey-500" data-test-id="optionalMarker">({{ 'forms.fieldWrapper.optionalMarker' | translate }})</span>
        }
        @if (props.showRequiredMarker && props.required) {
          <span data-test-id="requiredMarker">({{ 'forms.fieldWrapper.requiredMarker' | translate }})</span>
        }
      </label>
    </ng-container>
  }

  <nz-form-control
    [nzValidateStatus]="errorState"
    [nzExtra]="props.description"
    [nzErrorTip]="errorTpl"
  >
    <ng-container #fieldComponent />
    <ng-template #errorTpl let-control>
      <formly-validation-message [field]="field" />
    </ng-template>
  </nz-form-control>
</div>
